import { Form, Row } from 'antd';
import React, { useContext, useState } from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';
import CheckboxComponent from 'components/atoms/CheckboxComponent';
import Paragraph from 'components/atoms/Paragraph';
import Title from 'components/atoms/Title';
import LoadingWrapper from 'components/hoc/LoadingWrapper';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';
import FormWrapper from 'components/molecules/FormWrapper';

import useNavigateWorkaround from 'hooks/useNavigateWorkaround';
import useProfily from 'hooks/useProfily';

import { ECrsStav, ICrsDotaznik, crsDotaznikSend } from 'services/poDlt/crs';

import routePathEnum from 'enums/routePathEnum';

interface ICrsProhlaseniPage {
    prevStep: () => void;
    zadostID: number;
    dotaznikData: ICrsDotaznik;
}

const CrsProhlaseni: React.FC<ICrsProhlaseniPage> = ({ prevStep, zadostID, dotaznikData }) => {
    const { navigateWorkaround } = useNavigateWorkaround();
    const { aktivniFirma, menuProfile } = useContext(Context);
    const { setLevel } = useProfily();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState<boolean>(false);
    const viewOnly = dotaznikData?.stav === ECrsStav.ZPRAC;
    const [isChecked, setIsChecked] = useState<boolean>(viewOnly);
    const baseURL = `${routePathEnum.FIRMA_PLAIN}${aktivniFirma?.iducet}`;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onFinish = () => {
        setLoading(true);
        const finishData = {
            ...dotaznikData,
            stav: ECrsStav.ZPRAC
        } as ICrsDotaznik;

        crsDotaznikSend('POST', finishData, zadostID)
            .then(() => {
                setLevel('menuProfile', {
                    ...menuProfile!,
                    crsHotovo: true
                });
                navigateWorkaround(`${baseURL}${routePathEnum.CRS_DOTAZNIK_PREHLED}`);
            })
            .finally(() => setLoading(false));
    };

    return (
        <LoadingWrapper loading={loading}>
            <FormWrapper outForm={form} onFinish={onFinish} preserve={false}>
                <Title text="CRS_DOTAZNIK_PROHLASENI" level={5} />
                <Paragraph
                    text="CRS_DOTAZNIK_PROHLASENI_TEXT1"
                    style={{
                        marginTop: 16,
                        display: 'block'
                    }}
                />
                <Paragraph
                    text="CRS_DOTAZNIK_PROHLASENI_TEXT2"
                    style={{
                        marginTop: 16,
                        display: 'block'
                    }}
                />
                <Paragraph
                    text="CRS_DOTAZNIK_PROHLASENI_TEXT3"
                    style={{
                        marginTop: 16,
                        display: 'block'
                    }}
                />
                <Paragraph
                    text="CRS_DOTAZNIK_PROHLASENI_TEXT4"
                    style={{
                        marginTop: 16,
                        display: 'block'
                    }}
                />
                <Row
                    style={{
                        marginTop: 26
                    }}
                >
                    <CheckboxComponent
                        name="souhlas"
                        checkboxText={<TranslateText>POTVRZENI_CHECKBOX</TranslateText>}
                        onChange={() => setIsChecked(pv => !pv)}
                        checked={isChecked}
                        defaultChecked={isChecked}
                        disabled={viewOnly}
                    />
                </Row>
                <Row className="button-row">
                    <ButtonComponent buttontext="ZPET" type="default" onClick={() => prevStep()} id="isinZpetBtn" />
                    {!viewOnly && (
                        <ButtonComponent
                            disabled={!isChecked}
                            buttontext="ODESLAT"
                            onClick={() => form.submit()}
                            id="crsPokracovatBtn"
                        />
                    )}
                </Row>
            </FormWrapper>
        </LoadingWrapper>
    );
};

export default CrsProhlaseni;
